{
  "el": {
    "milestone": {
      "actions": {
        "activate": "Ενεργοποίηση",
        "active": "Ενεργό",
        "create": "Δημιουργία ορόσημου",
        "deactivate": "Απενεργοποίηση",
        "delete": "Διαγραφή",
        "delete_milestones": "Διαγραφή ορόσημου | Διαγραφή {count} ορόσημων",
        "new": "Ορόσημο"
      },
      "activate": {
        "confirm": "Ενεργοποίηση",
        "intro": "Η ενεργοποίηση αυτού του ορόσημου θα:",
        "past_warning": "Η επιστροφή σε προηγούμενο ορόσημο δεν αναιρεί όσα έχουν ήδη γίνει. Ό,τι έχει κοινοποιηθεί στους πελάτες δεν ανακαλείται αυτόματα.",
        "title": "Ενεργοποίηση ορόσημου",
        "verb_default": "ξεκινήσει",
        "verb_share": "κοινοποιήσει"
      },
      "attach": {
        "add": "Προσθήκη",
        "add_kind": "Προσθήκη: {kind}",
        "assigned_tag": "Ανατεθειμένο",
        "back": "Πίσω",
        "counts": "{available} διαθέσιμα · {assigned} ήδη ανατεθειμένα",
        "description_decision": "Επιλογές που πρέπει να κάνει ο πελάτης",
        "description_survey": "Ερωτηματολόγια για τη συλλογή απαντήσεων",
        "empty": "Δεν υπάρχουν διαθέσιμα στοιχεία",
        "empty_state_description": "Με βάση το πλάνο σου μπορείς να προσθέσεις σε αυτό το ορόσημο: {kinds}.",
        "intro": "Διάλεξε τον τύπο στοιχείου που θέλεις να συνδέσεις με αυτό το ορόσημο.",
        "next": "Επόμενο",
        "search": "Αναζήτηση",
        "select_intro": "Επίλεξε τι θέλεις να προσθέσεις: {kind}.",
        "subtitle": "Στο ορόσημο: {name}",
        "success": "Τα στοιχεία προστέθηκαν",
        "title": "Προσθήκη στοιχείων"
      },
      "labels": {
        "add_element": "Προσθήκη στοιχείου",
        "add_kind": "Προσθήκη: {kind}",
        "assign_units": "Ανάθεση ακινήτων",
        "assigned_count": "0 ανατεθειμένα | 1 ανατεθειμένο | {count} ανατεθειμένα",
        "assigned_elements": "Ανατεθειμένα στοιχεία",
        "assigned_empty_description": "Σύνδεσε με αυτό το ορόσημο: {kinds}",
        "assigned_empty_title": "Κανένα στοιχείο ακόμη",
        "bulk_assign_title": "Επίλεξε τα ακίνητα στα οποία θέλεις να ανατεθεί το ορόσημο «{milestone_name}»",
        "edit_milestone": "Επεξεργασία ορόσημου",
        "empty_state_subtitle": "Τα ορόσημα κάνουν την πορεία της κατασκευής πιο διαφανή για τους αγοραστές",
        "empty_state_title": "Δημιούργησε ένα νέο ορόσημο",
        "finished_on": "Ολοκληρώθηκε {date}",
        "future_milestones": "Μελλοντικά ορόσημα",
        "kind_decision": "Απόφαση | Αποφάσεις",
        "kind_survey": "Ερωτηματολόγιο | Ερωτηματολόγια",
        "kind_todo": "Εργασία | Εργασίες",
        "milestone": "Ορόσημο",
        "milestone_name": "Όνομα ορόσημου",
        "milestone_unit_count": "0 ακίνητα | 1 ακίνητο | {count} ακίνητα",
        "milestones": "Ορόσημα",
        "new_milestone": "Νέο ορόσημο",
        "no_milestone": "Δεν έχει ανατεθεί ακόμη ορόσημο",
        "no_results": "Δεν βρέθηκαν ορόσημα",
        "past_milestones": "Προηγούμενα ορόσημα",
        "please_select": "Επίλεξε ένα νέο ορόσημο",
        "position": "Θέση",
        "search_empty_state": "Δεν έχουν δημιουργηθεί ακόμη ορόσημα. Κάνε κλικ εδώ για να ξεκινήσεις",
        "started_on": "Ξεκίνησε {date}",
        "status_active": "Ενεργό",
        "status_completed": "Ολοκληρωμένο",
        "status_planned": "Προγραμματισμένο",
        "status_planned_subtitle": "Δεν έχει ξεκινήσει ακόμη",
        "unit_timeline_empty": "Δεν έχουν δημιουργηθεί ακόμη ορόσημα για αυτό το έργο.",
        "units": "Ακίνητα",
        "units_without_milestone": "1 ακίνητο χωρίς ορόσημο | {count} ακίνητα χωρίς ορόσημο",
        "warning_delete": "Αν διαγράψεις ένα ορόσημο που έχει ανατεθεί σε ακίνητο, ο πελάτης δεν θα βλέπει πια σε ποιο ορόσημο βρίσκεται το ακίνητό του. Φρόντισε να αναθέσεις νέο ορόσημο σε αυτά τα ακίνητα."
      },
      "toasts": {
        "bulk_assigned": "Το ορόσημο ανατέθηκε με επιτυχία στα επιλεγμένα ακίνητα",
        "create_success": "Το ορόσημο δημιουργήθηκε με επιτυχία",
        "deactivate_success": "Το ορόσημο απενεργοποιήθηκε με επιτυχία",
        "sup_assigned": "Το ορόσημο ενεργοποιήθηκε με επιτυχία",
        "update_success": "Τα ορόσημα ενημερώθηκαν με επιτυχία"
      },
      "validation": {
        "needName": "Απαιτείται όνομα",
        "needNamePrimary": "Απαιτείται όνομα στην κύρια γλώσσα ({language})"
      }
    }
  }
}
